import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import OttoConnection from "@/components/connections/OttoConnection.vue";

const routes: Array<RouteRecordRaw> = [

  {
    name: 'admin',
    path: '/',
    redirect: {name: 'orders' } ,
    component: AppLayout,
    children: [
      {
        name: 'orders',
        path: 'orders',
        redirect: { name: 'order-list' },
        children: [
          {
            name: 'order-list',
            path: '',
            component: () => import('../pages/orders/OrderList.vue'),
          },
          {
            name: 'order-details',
            path: '/:id',
            component: () => import('../pages/orders/OrderDetails.vue'),
          }
        ]
      },
      {
        name: 'stocks',
        path: '/stocks',
        redirect: {name: 'stock-list' } ,
        children: [
          {
            name: 'stock-list',
            path: '',
            component: () => import('../pages/stocks/StockList.vue'),
          },
          {
            name: 'product-list',
            path: ':id',
            component: () => import('../pages/stocks/ProductList.vue'),
          },
          {
            name: 'product-create',
            path: ':id/product-create',
            component: () => import('../pages/stocks/EditProduct.vue')
          },
          {
            name: 'product-edit',
            path: ':id/product-edit/:productId',
            component: () => import('../pages/stocks/EditProduct.vue')
          }
        ]
      },
      {
        name: 'categories',
        path: 'categories',
        redirect: { name: 'category-list' },
        children: [
          {
            name: 'category-list',
            path: '',
            component: () => import('../pages/categories/CategoryList.vue'),
          },
          {
            name: 'category-edit',
            path: 'edit/:id',
            component: () => import('../pages/categories/EditCategory.vue'),
          },
          {
            name: 'category-create',
            path: 'create',
            component: () => import('../pages/categories/EditCategory.vue'),
          },
        ],
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'actions',
        path: 'actions',
        component: () => import('../pages/actions/Actions.vue'),
      },
      {
        name: 'tracking',
        path: 'trackings',
        component: () => import('../pages/tracking/Tracking.vue'),
      },
      {
        name: 'shipping',
        path: 'shipping',
        component: () => import('../pages/shipping/ShippingPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        redirect: { name: 'settings-list' },
        children: [
          {
            name: 'settings-list',
            path: 'settings',
            component: () => import('../pages/settings/Settings.vue'),
          },
          {
            name: 'services',
            path: '',
            redirect: {name: 'service-edit'},
            children: [
              {
                name: 'service-list',
                path:'services-list',
                component: () => import('../pages/settings/services/ServiceList.vue')
              },
              {
                name: 'service-edit',
                path:'services',
                component: () => import('../pages/settings/services/ServiceEdit.vue')
              }
            ]
          }
        ]
      },
      {
        name: 'app-settings',
        path:'/app-settings',
        component: () => import('../pages/app-settings/AppSettings.vue')
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: 'connection',
    path: '/connection',
    component: EmptyLayout,
    children: [
      {
        name: 'otto',
        path: 'otto',
        component: OttoConnection
      }
    ]
  },
  {
    path: '/connection/ebay/',
    component: () => import('../pages/connections/EbayConnection.vue')
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'orders' },
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },

]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
